import './HangupBadge.css';
import getHangup from '../../data/getHangup';

function HangupBadge({ conversation }) {
    const hangup = getHangup(conversation);
    if (!hangup) return null;

    return (
        <span className={'hangup_badge hangup_badge_' + hangup.by} title={hangup.title}>
            <i className={'fas ' + hangup.icon}></i>
            {hangup.label}
        </span>
    );
}

export default HangupBadge;
